module.exports = __webpack_public_path__ + "static/media/limerickuni.12579ecf.png";